import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from 'react-bootstrap'
import EcoStart from '../img/eco-start.png'
import piloteSmart from '../img/pilote-smart.png'
import parcours from '../img/parcours.png'
import vueHorizon from '../img/vue-horizon.png'
import { Link } from 'react-router'
import { useContext } from 'react'
import AuthContext from '../context/AuthContext'
import { freeSubscription } from '../utils/FormatDate'

export const Subscription = ({ data, isSelected, isProfile = false, isDisabled = false }) => {

  const { userInfo } = useContext(AuthContext);
  const createdAt = userInfo?.usrCreatedAt?.date;

  const dateExpired = freeSubscription(createdAt ?? '');

  if (data === 0) {
    return (
      <div className=''>
        <Card className={`${isSelected ? 'kl-selected' : ''}${isDisabled ? 'kl-disabled' : ''}`}>
          <Card.Body className='kl-card-payment'>
            <Card.Title className='kl-card-title-profile'>
              <div className='kl-image-subscribe-card'>
                <img src={EcoStart} alt='eco start' />
              </div>
              <div className='kl-elemet-card-title'>
                <p>0€ /mois </p>
                {
                  dateExpired ? (
                    <span>Forfait actuel expire dans {dateExpired} jours</span>
                  ) : (
                    <span>Forfait expiré</span>
                  )
                }

              </div>
            </Card.Title>
            <Card.Subtitle className='kl-card-subtitle'>
              Eco start
            </Card.Subtitle>
            <div className='kl-card-text-sub'>Pédalez vers la réussite, sans frais !</div>
            <div className='kl-text-forfait'>
              <strong>Ce que contient ce forfait:</strong>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Espace client et synchronisation bancaire
                </p>
              </div>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Accès au scan et au téléchargement de factures
                </p>
              </div>
            </div>
            <Card.Text />
            {isProfile && (
              <div>
                <Link to="/subscription-list" className='kl-button-change-sub'>
                  <div className='kl-change-package-text'>
                    <span>Changer de forfait</span>
                  </div>
                  <div className='kl-change-package-icon'>
                    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.19629 1.70226C5.05766 1.61069 4.86912 1.62513 4.74707 1.74718C4.62502 1.86924 4.61058 2.05777 4.70215 2.1964L4.74707 2.25304L6.63672 4.14269H2.5C2.30276 4.14269 2.14258 4.30287 2.14258 4.50011C2.14258 4.69736 2.30276 4.85753 2.5 4.85753H6.63672L4.74707 6.74718C4.6076 6.88665 4.6076 7.11357 4.74707 7.25304C4.88654 7.39251 5.11346 7.39251 5.25293 7.25304L7.75293 4.75304C7.8924 4.61357 7.8924 4.38666 7.75293 4.24718L5.25293 1.74718L5.19629 1.70226Z" fill="black" />
                    </svg>
                  </div>
                </Link>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    )
  }

  if (data >= 1 && data <= 4900) {
    return (
      <div className=''>
        <Card className={`${isSelected ? 'kl-selected' : ''}${isDisabled ? 'kl-disabled' : ''}`}>
          <Card.Body className='kl-card-payment'>
            <Card.Title className='kl-card-title-profile'>
              <div className='kl-image-subscribe-card'>
                <img src={piloteSmart} alt='eco start' />
              </div>
              <div className='kl-elemet-card-title'>
                <p>{(data / 100).toFixed(0)}€ /mois </p>
              </div>
            </Card.Title>
            <Card.Subtitle className='kl-card-subtitle'>
              Pilote Smart
            </Card.Subtitle>
            < div className='kl-card-text-sub'>
              La comptabilité agile pour les solo-entrepreneurs !
            </div>
            <div className='kl-text-forfait'>
              <strong>Ce que contient ce forfait:</strong>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Toutes les fonctionnalités de l’Eco-Start
                </p>
              </div>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Saisie comptable de l’ensemble des factures achats/ventes
                </p>
              </div>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Déclaration de TVA et Télétransmission au centre des impôts
                </p>
              </div>
            </div>
            <Card.Text />
            {isProfile && (
              <div>
                <Link to="/subscription-list" className='kl-button-change-sub'>
                  <div className='kl-change-package-text'>
                    <span>Changer de forfait</span>
                  </div>
                  <div className='kl-change-package-icon'>
                    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.19629 1.70226C5.05766 1.61069 4.86912 1.62513 4.74707 1.74718C4.62502 1.86924 4.61058 2.05777 4.70215 2.1964L4.74707 2.25304L6.63672 4.14269H2.5C2.30276 4.14269 2.14258 4.30287 2.14258 4.50011C2.14258 4.69736 2.30276 4.85753 2.5 4.85753H6.63672L4.74707 6.74718C4.6076 6.88665 4.6076 7.11357 4.74707 7.25304C4.88654 7.39251 5.11346 7.39251 5.25293 7.25304L7.75293 4.75304C7.8924 4.61357 7.8924 4.38666 7.75293 4.24718L5.25293 1.74718L5.19629 1.70226Z" fill="black" />
                    </svg>
                  </div>
                </Link>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    )
  }

  if (data >= 5000 && data <= 7900) {
    return (
      <div className=''>
        <Card className={`${isSelected ? 'kl-selected' : ''}${isDisabled ? 'kl-disabled' : ''}`}>
          <Card.Body className='kl-card-payment'>
            <Card.Title className='kl-card-title-profile'>
              <div className='kl-image-subscribe-card'>
                <img src={parcours} alt='eco start' />
              </div>
              <div className='kl-elemet-card-title'>
                <p>{(data / 100).toFixed(0)}€ /mois </p>
              </div>
            </Card.Title>
            <Card.Subtitle className='kl-card-subtitle'>
              Parcours Sérénité
            </Card.Subtitle>
            < div className='kl-card-text-sub'>
              Le confort comptable pour votre entreprise en expansion !
            </div>
            <div className='kl-text-forfait'>
              <strong>Ce que contient ce forfait:</strong>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Toutes les fonctionnalités de l’Eco-Start
                </p>
              </div>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>Bilan de fin d’année</p>
              </div>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Accès privilégié à votre comptable dédié (appels illimités)
                </p>
              </div>
            </div>
            <Card.Text />
            {isProfile && (
              <div>
                <Link to="/subscription-list" className='kl-button-change-sub'>
                  <div className='kl-change-package-text'>
                    <span>Changer de forfait</span>
                  </div>
                  <div className='kl-change-package-icon'>
                    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.19629 1.70226C5.05766 1.61069 4.86912 1.62513 4.74707 1.74718C4.62502 1.86924 4.61058 2.05777 4.70215 2.1964L4.74707 2.25304L6.63672 4.14269H2.5C2.30276 4.14269 2.14258 4.30287 2.14258 4.50011C2.14258 4.69736 2.30276 4.85753 2.5 4.85753H6.63672L4.74707 6.74718C4.6076 6.88665 4.6076 7.11357 4.74707 7.25304C4.88654 7.39251 5.11346 7.39251 5.25293 7.25304L7.75293 4.75304C7.8924 4.61357 7.8924 4.38666 7.75293 4.24718L5.25293 1.74718L5.19629 1.70226Z" fill="black" />
                    </svg>
                  </div>
                </Link>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    )
  }

  if (data >= 8000 && data <= 9900) {
    return (
      <div className=''>
        <Card className={`${isSelected ? 'kl-selected' : ''}${isDisabled ? 'kl-disabled' : ''}`}>
          <Card.Body className='kl-card-payment'>
            <Card.Title className='kl-card-title-profile'>
              <div className='kl-image-subscribe-card'>
                <img src={vueHorizon} alt='eco start' />
              </div>
              <div className='kl-elemet-card-title'>
                <p>{(data / 100).toFixed(0)}€ /mois </p>
              </div>
            </Card.Title>
            <Card.Subtitle className='kl-card-subtitle'>
              Vue Horizon
            </Card.Subtitle>
            < div className='kl-card-text-sub'>
              Survolez vos défis comptables avec notre service premium !
            </div>
            <div className='kl-text-forfait'>
              <strong>Ce que contient ce forfait:</strong>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>
                  Toutes les fonctionnalités du Parcours Sénérité
                </p>
              </div>
              <div className='kl-description-card'>
                <FontAwesomeIcon icon={faStar} className='kl-list-star' />
                <p className='kl-text-xs'>Fiche de paie (1 par mois)</p>
              </div>
            </div>
            <Card.Text />
            {isProfile && (
              <div>
                <Link to="/subscription-list" className='kl-button-change-sub'>
                  <div className='kl-change-package-text'>
                    <span>Changer de forfait</span>
                  </div>
                  <div className='kl-change-package-icon'>
                    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.19629 1.70226C5.05766 1.61069 4.86912 1.62513 4.74707 1.74718C4.62502 1.86924 4.61058 2.05777 4.70215 2.1964L4.74707 2.25304L6.63672 4.14269H2.5C2.30276 4.14269 2.14258 4.30287 2.14258 4.50011C2.14258 4.69736 2.30276 4.85753 2.5 4.85753H6.63672L4.74707 6.74718C4.6076 6.88665 4.6076 7.11357 4.74707 7.25304C4.88654 7.39251 5.11346 7.39251 5.25293 7.25304L7.75293 4.75304C7.8924 4.61357 7.8924 4.38666 7.75293 4.24718L5.25293 1.74718L5.19629 1.70226Z" fill="black" />
                    </svg>
                  </div>
                </Link>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    )
  }
}
